<template>
    <div v-if="user">

        <div v-if="!userOrders" class="box-shadow h-100">
            <div class="h5 mb-0">История заказов пуста.</div>
            <div class="h5 mb-0">Перейдите в <router-link to="/catalog" class="color-primary">каталог</router-link> и выберите необходимые для вас товары.</div>
        </div>

        <div v-if="userOrders && userOrders.length" class="box-shadow pl-0 pr-0">
            <div class="order-table">
                <div class="order-table__header">
                    <div>№</div>
                    <div>Срок аренды</div>
                    <div>Номер заказа</div>
                    <div>Статус</div>
                </div>


                <div class="order-table__body" role="tablist">
                    <div v-for="(item, i) in userOrders" :key="i">
                        <account-item :code="getUserCode()" :item="item" :i="i"></account-item>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                userOrders: null,
            }
        },

        computed: {
            user() {
                return this.$store.getters.getUser;
            }
        },

        mounted() {
            this.init();
        },

        methods: {
            init() {
                let url = '/api/history-orders';
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem('token')
                    }
                };

                axios.post(url, {}, options)
                    .then(response => {
                        if(response.status == 200) {
                            this.userOrders = Object.values(response.data.userOrders);
                        }
                    })
            },
            getUserCode() {
                if (this.$store.getters.getUser !== null) {
                    return this.$store.getters.getUser.userData.code;
                }
                return null;
            }
        }

    }
</script>
